import { MESSAGE_STATUS_TOAST_MAP } from '~/core/shared/constants/messageStatusToastMap';
import { useToast } from '~/core/shared/lib/chakraUi/hooks';
import { useSubscribeToDocumentNotification } from '~/core/shared/websocketApi/document';

export const useDocumentNotificationNotification = (uuid: string): void => {
  const toast = useToast();

  useSubscribeToDocumentNotification(uuid, ({ message, status }) => {
    toast({
      id: `document-notification-${status}-${message}`,
      description: message,
      closable: true,
      type: MESSAGE_STATUS_TOAST_MAP[status] ?? 'info',
    });
  });
};
